import { createSelector } from '@reduxjs/toolkit';
import { observeStore } from '@ff-os/pdp-shared-redux/observeStore';
import { PaintTarget } from '@ff-os/rendering-shared/targets';
import { selectActiveVariant } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { selectAllVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState, GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { createPaintables } from '@ff-scene-plugins/gift-shared/paintables';
import { selectActiveCommission, selectActivePrefabId } from '../_redux-meta';
import { selectInputsWithoutComputedProperties } from '../helpers/selectInputsWithoutComputedProperties';

export const addDesignChangeListener = (store: GiftPdpStore, callback: () => void) => {
    observeStore(store, selectObservables, callback);
};

const selectObservables = createSelector([
    (state: GiftPdpState) => selectActivePrefabId(state),
    (state: GiftPdpState) => selectActiveCommission(state),
    (state: GiftPdpState) => selectVariablePaintables(state)
], (...observables) => observables);

const selectVariablePaintables = createSelector([
    (state: GiftPdpState) => selectAllVariables(state),
    (state: GiftPdpState) => selectInputsWithoutComputedProperties(state).entities,
    (state: GiftPdpState) => selectActiveVariant(state),
    (state: GiftPdpState) => state.auth.jwt,
    (state: GiftPdpState) => 'mockup' as PaintTarget
], createPaintables);